module.exports = __webpack_public_path__ + "static/media/grey.205fc39f.png";